// extracted by mini-css-extract-plugin
module.exports =  {"link":"RSqdS33","pricing-factor":"IHEIdFc","pricingFactor":"IHEIdFc"};